import { COUNTER_UPDATE } from '../actions/counter'
import Vue from 'vue'
import VueX from 'vuex'
// import User from '@/lib/transfer-objects/User'
// import EventBus from '@/event-bus'

Vue.use(VueX)

const state = {
  counters: {
    newUsers: 0,
    newMessages: 0
  }
}

const getters = {
  counters (state) {
    return state.counters
  }
}

const actions = {
  [COUNTER_UPDATE]: ({commit, dispatch}, {newUsers = 0, newMessages = 0}) => {
    commit(COUNTER_UPDATE, {newUsers, newMessages})
  }
}

const mutations = {
  [COUNTER_UPDATE]: (state, {newUsers, newMessages}) => {
    state.counters.newUsers = newUsers
    state.counters.newMessages = newMessages
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/counter.js